import { useMemo } from 'react'
import { Modal } from 'react-bootstrap'
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { useSearch } from 'hooks/react.hooks'
import { useTranslationRankmi } from 'helpers/translations.helper'
import { Types } from '../../constants'
import { LoginSenceForm } from './LoginSenceForm'

export const LoginSence = () => {
  const t = useTranslationRankmi({
    prefix: 'courses.show.sence',
  })
  const [{ errorCode }] = useSearch<'errorCode'>()
  const [{ type }] = useSearch<'type'>()

  const title = useMemo(() => {
    if (errorCode && type !== Types.logout_error)
      return (
        <>
          <FontAwesomeIcon icon={faExclamationCircle} className="red mr-2" />
          {t('login.titleError')}
        </>
      )
    return t('login.title')
  }, [errorCode, t, type])

  return (
    <Modal size="lg" show centered>
      <Modal.Header className="ml-3 mr-3 mt-2 pb-2">
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="ml-3 mr-3">
        <p>{!errorCode && t('login.message')}</p>
        <p>{errorCode && t(`errors.${errorCode}`)}</p>
        <div className="d-flex justify-content-center">
          <LoginSenceForm />
        </div>
      </Modal.Body>
    </Modal>
  )
}
